import { c as _c } from "react/compiler-runtime";
import { Command } from 'cmdk';
import { useTranslation } from 'react-i18next';
type ComboListProps = {
  emptyText: string;
  children: React.ReactNode;
};
const ComboList = t0 => {
  const $ = _c(9);
  const {
    emptyText,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "components.combo"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("ui", t1);
  let t2;
  if ($[1] !== emptyText || $[2] !== t) {
    t2 = emptyText || t("empty-state-default");
    $[1] = emptyText;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const emptyLabel = t2;
  let t3;
  if ($[4] !== emptyLabel) {
    t3 = <Command.Empty className="text-body-2 flex items-center justify-center text-quaternary h-full p-3">{emptyLabel}</Command.Empty>;
    $[4] = emptyLabel;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== children || $[7] !== t3) {
    t4 = <Command.List className="h-[var(--cmdk-list-height)] scroll-pt-2 scroll-pb-2 transition-[height] duration-100 ease-linear">{t3}{children}</Command.List>;
    $[6] = children;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
};
export default ComboList;